import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing12 } from 'autogen/design-tokens/tokens';
import { About } from 'autogen/translation-keys/trans-website-product-subscription';
import InlineButton from 'components/generic/InlineButton/InlineButton';
import InlineLinkActionButton from 'components/generic/InlineButton/InlineLinkActionButton';
import { useQuickView } from 'components/quickView';
import QuickView from 'components/quickView/quickView';
import type { LinkAction } from 'components/shared/Routing/components/LinkAction/shared/types';
import { fetchHTML } from 'modules/helpers/fetch';

const AboutButton = styled(InlineLinkActionButton)`
    display: inline-block;
    margin-top: ${Spacing12};
    margin-right: auto;
`;

export default function AboutSubscriptionButton({ linkAction }: { linkAction: LinkAction }): JSX.Element {
    const { t } = useTranslation();

    return (
        <AboutButton action={linkAction} fontWeight="semibold" target="_blank">
            {t(About)}
        </AboutButton>
    );
}
